import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LocalStorageService } from "src/app/common/LocalStorageService";
import { JwtDecodeService } from "src/app/common/login/others/JWTDecodeService";
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {

  // token: string | null;
  // platform: string = "Web";
  // locId: number = 0;

  // constructor(
  //   private authService: OktaAuthService,
  //   public persistenceService: LocalStorageService) {
  //   this.token = this.persistenceService.get("access_token");
  //   this.platform = this.persistenceService.get('OS')

  //   if (this.persistenceService.get("locId"))
  //     this.locId = JSON.parse(this.persistenceService.get("locId"));
  //   else
  //     this.locId = 0;
  // }

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   let newBody:any=req.body;
  //   // if(req.body!=null)
  //   //  {
  //   //   alert(req.body.toString())
  //   //   newBody=this.encryptCodeBefore(req.body.toString())
  //   //   alert(newBody)
  //   //  } 

  //   const modifiedReq = req.clone({
  //     headers: new HttpHeaders({
  //       Authorization: 'Bearer ' + this.persistenceService.get("access_token"),
  //       platform: this.platform,
  //       locId: this.locId,
  //       'X_Correlation_Id': this.calcCorrelationId(),
  //       'long': this.persistenceService?.get('long'),
  //       'lat': this.persistenceService?.get('lat'),
  //       'Access-Control-Allow-Origin':'*'

  //     }),
  //     body:newBody
  //   })
  //   return next.handle(modifiedReq);
  // }
  // encryptCodeBefore(data:AnyCnameRecord)
  // {
  //   //The key is the Base64 Encoded code of the actual password/key
  //   var parsedBase64Key = CryptoJS.enc.Base64.parse("QTc4YlVzNE5xcnM3MjkwYg==");
  //   return CryptoJS.AES.encrypt(data, parsedBase64Key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7
  //     });
  // }
  // calcCorrelationId() {
  //   var s = [];
  //   var hexDigits = "0123456789abcdef";
  //   for (var i = 0; i < 36; i++) {
  //     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  //   }
  //   s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  //   s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  //   s[8] = s[13] = s[18] = s[23] = "-";
  //   var uuid = s.join("");
  //   return uuid;
  // }


  token: string | null;
  platform: string = "Web";
  locId: number = 0;

  constructor(
    // private authService: OktaAuthService,
    public persistenceService: LocalStorageService, private tokenVerify: JwtDecodeService) {
    this.token = this.persistenceService.get("access_token");
    this.platform = this.persistenceService.get('OS')

    if (this.persistenceService.get("locId")){
      try{
        this.locId = JSON.parse(this.persistenceService.get("locId"));
      }catch(err){
        console.log(err);
      }
    }
    else
      this.locId = 0;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('/assets/')) {
      return next.handle(req);
    }
    if (window.location.href.includes("access_token=")) {
      const url = new URL(window.location.href);
      const value = url.searchParams.get('access_token');
      this.persistenceService.set("access_token", value);
    }
    // console.log("Auth Interceted Token : "+this.tokenVerify.isTokenValid(this.persistenceService.get("access_token")))
    // if (!this.tokenVerify.isTokenValid(this.persistenceService.get("access_token"))) {
    //   this.persistenceService.set("access_token", "NA")
    //   this.persistenceService.set("refresh_token", "NA")
    //   let cnt = 1;
    //   if (this.persistenceService.get("allEMails") == undefined || this.persistenceService.get("allEMails") == null) {
    //     cnt = 1
    //   }
    //   else {
    //     cnt = this.persistenceService.get("allEMails").split(",").length
    //   }
    //   window.location.href = environment.loginLogoutUrl + "signin?cnt=" + cnt + "&source=" + environment.baseURL + "/";
    // }


    let newBody: any = req.body;
    const modifiedReq = req.clone({
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.persistenceService.get("access_token"),
        platform: this.platform,
        locId: this.locId,
        'X_Correlation_Id': this.calcCorrelationId(),
        'long': this.persistenceService?.get('long'),
        'lat': this.persistenceService?.get('lat'),
        'Access-Control-Allow-Origin': '*'

      }),
      body: newBody
    })
    return next.handle(modifiedReq);
  }

  calcCorrelationId() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
  }
}